module.exports = __webpack_public_path__ + "static/img/P3.6d94279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/P3.jpg
// module id = e1Su
// module chunks = 1